import { Helmet } from "react-helmet-async";
import { Link } from "react-router";

import { Button, EmptyState, Flex, Icons } from "@ir/ui";

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | DM WebApp</title>
      </Helmet>
      <Flex className="not-found-page" align="center" justifyContent="center">
        <EmptyState
          icon={Icons.InfoOctagon}
          title="404 - Page Not Found"
          description="The page you are looking for might have been removed or is temporarily unavailable."
        >
          <Link to="/">
            <Button color="primary">Go to Home</Button>
          </Link>
        </EmptyState>
      </Flex>
    </>
  );
};

export default NotFound;
